import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirGallery } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirGalleriesAdapter = createEntityAdapter<JSONApiDataObject<BsdirGallery>>({
  selectId: item => item.id
});

export const bsdirGalleriesSlice = createSlice({
  name: 'bsdirGalleries',
  initialState: bsdirGalleriesAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirGallery>),
  reducers: {
    bsdirGalleriesAdded: (state, action) => {
      bsdirGalleriesAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirGalleriesSelectors = bsdirGalleriesAdapter.getSelectors(
  (state: RootState) => state.bsdir.galleries);
export default bsdirGalleriesSlice.reducer;
